import { render } from "./VButton.vue?vue&type=template&id=b2855e78"
const script = {}

import "./VButton.vue?vue&type=style&index=0&id=b2855e78&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__